export default __webpack_public_path__ + "static/media/FoodChainGrassland_12.3ccf8042.png";